// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailsPrintInvoiceButton_container__350cM","text":"OrderDetailsPrintInvoiceButton_text__10CQk","text-ltr":"OrderDetailsPrintInvoiceButton_text-ltr__3XmlR"};